import { z } from "zod";

// ---------- Per-step schemas ----------

export const contactFormSchema = z.object({
  contactName: z.string().min(1, "Contact name is required"),
  contactEmail: z
    .string()
    .email("Must be a valid email")
    .min(1, "Contact email is required"),
  contactPhone: z.string().min(1, "Contact phone is required"),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;

const attendeeItemSchema = z.object({
  id: z.number().optional(),
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email").optional(),
  isSelected: z.boolean().default(true),
  specialRequests: z.string().optional(),
});

export const attendeesFormSchema = z.object({
  attendees: z.array(attendeeItemSchema).default([]),
});

export type AttendeesFormData = z.infer<typeof attendeesFormSchema>;

export const reviewFormSchema = z.object({
  groupNotes: z.string().optional(),
});

export type ReviewFormData = z.infer<typeof reviewFormSchema>;

// ---------- Combined (for backward compat) ----------

export const eventRegistrationSchema = contactFormSchema
  .merge(attendeesFormSchema)
  .merge(reviewFormSchema);

export type EventRegistrationFormData = z.infer<typeof eventRegistrationSchema>;
